import React from "react"
import styles from "./HeaderStyles.module.css"
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";

const Header = () => {
  return (
    <>
      <div className={styles.desktop}>
        <DesktopHeader />
      </div>
      <div className={styles.mobile}>
        <MobileHeader />
      </div>
    </>
  )
}

export default Header;